import { createDarkTheme, createLightTheme } from '@fluentui/react-components'
import { typographyOverrides } from './fontSize'

const myNewTheme = {
  10: '#020205',
  20: '#131623',
  30: '#1B243D',
  40: '#222F54',
  50: '#273B6B',
  60: '#2D4883',
  70: '#32559D',
  80: '#3962B4',
  90: '#516FBB',
  100: '#657DC3',
  110: '#788BCA',
  120: '#8A99D1',
  130: '#9CA8D8',
  140: '#AEB7DF',
  150: '#BFC6E6',
  160: '#D1D6ED',
}
const commonStyles = {
    fontFamilyBase: "'Source Sans 3', sans-serif,  Arial, Helvetica",
}
const brandTokens = createLightTheme(myNewTheme);
const brandTokensDark = createDarkTheme(myNewTheme);

const lightTheme = {
  ...brandTokens,
  ...typographyOverrides,
  ...commonStyles
}

const darkTheme = {
  ...brandTokensDark,
  ...typographyOverrides,
  ...commonStyles,
   colorNeutralBackground1: "#1e1e1e",
}


const Theme = {
  darkTheme,
  lightTheme,
}

export default Theme
